/**
 * Promotion Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PageRequestDTO } from './pageRequestDTO';


export interface CouponFilterDTO { 
    id?: number;
    couponCode?: string;
    couponName?: string;
    couponType?: CouponFilterDTO.CouponTypeEnum;
    discountType?: CouponFilterDTO.DiscountTypeEnum;
    beginDiscountValue?: number;
    endDiscountValue?: number;
    beginMinOrderAmount?: number;
    endMinOrderAmount?: number;
    beginMaxDiscountAmount?: number;
    endMaxDiscountAmount?: number;
    startDate?: string;
    endDate?: string;
    startUsageLimit?: number;
    endUsageLimit?: number;
    startPerCustomerLimit?: number;
    endPerCustomerLimit?: number;
    channelRestriction?: string;
    paymentMethodRestriction?: string;
    membershipLevel?: string;
    eventType?: string;
    creationDate?: string;
    lastUpdateDate?: string;
    deleteFlag?: boolean;
    status?: string;
    isActive?: boolean;
    pageRequest?: PageRequestDTO;
}
export namespace CouponFilterDTO {
    export const CouponTypeEnum = {
        FlatDiscount: 'FLAT_DISCOUNT',
        PercentageDiscount: 'PERCENTAGE_DISCOUNT',
        TieredDiscount: 'TIERED_DISCOUNT',
        BuyXGetY: 'BUY_X_GET_Y',
        ComboBundlePricing: 'COMBO_BUNDLE_PRICING',
        MixAndMatch: 'MIX_AND_MATCH',
        DiscountOnTotalBill: 'DISCOUNT_ON_TOTAL_BILL',
        ConditionalDiscount: 'CONDITIONAL_DISCOUNT',
        MembershipPricing: 'MEMBERSHIP_PRICING',
        PointsLoyaltyRewards: 'POINTS_LOYALTY_REWARDS',
        ChannelSpecific: 'CHANNEL_SPECIFIC',
        SeasonalEvent: 'SEASONAL_EVENT',
        PaymentPartner: 'PAYMENT_PARTNER',
        CouponVoucher: 'COUPON_VOUCHER',
        Cashback: 'CASHBACK',
        Gamification: 'GAMIFICATION',
        DivideFlag: 'DIVIDE_FLAG',
        PlatformDivideAmount: 'PLATFORM_DIVIDE_AMOUNT',
        VendorDivideAmount: 'VENDOR_DIVIDE_AMOUNT',
        ProductSpecific: 'PRODUCT_SPECIFIC',
        OrderWide: 'ORDER_WIDE',
        Shipping: 'SHIPPING',
        LoyaltyReward: 'LOYALTY_REWARD'
    } as const;
    export type CouponTypeEnum = typeof CouponTypeEnum[keyof typeof CouponTypeEnum];
    export const DiscountTypeEnum = {
        Percentage: 'PERCENTAGE',
        FixedAmount: 'FIXED_AMOUNT',
        FreeItem: 'FREE_ITEM',
        FreeShipping: 'FREE_SHIPPING',
        TieredPercentage: 'TIERED_PERCENTAGE',
        TieredFixedAmount: 'TIERED_FIXED_AMOUNT',
        BundlePrice: 'BUNDLE_PRICE',
        MixMatchPrice: 'MIX_MATCH_PRICE',
        CashbackPercentage: 'CASHBACK_PERCENTAGE',
        CashbackFixedAmount: 'CASHBACK_FIXED_AMOUNT',
        PointsEarn: 'POINTS_EARN',
        PointsRedeem: 'POINTS_REDEEM'
    } as const;
    export type DiscountTypeEnum = typeof DiscountTypeEnum[keyof typeof DiscountTypeEnum];
}


